
const WhyChooseUs = () => {
  const features = [
    {
      icon: 'ri-price-tag-3-line',
      title: 'Transparent Pricing',
      description: 'No hidden fees or surprise charges. Get clear, upfront quotes for all removals and landscaping services.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Insured Transport',
      description: 'All vehicles fully insured for your peace of mind. Your belongings are protected throughout the journey.',
    },
    {
      icon: 'ri-map-pin-user-line',
      title: 'Local Expertise',
      description: 'Born and raised in KZN. We know every route, from Durban city to rural areas across the province.',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Flexible Booking',
      description: 'Same-day service available. Book online, via WhatsApp, or phone. We work around your schedule.',
    },
  ];

  return (
    <section className="py-20 bg-lightgray">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Why Choose Look Who's Moving
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${feature.icon} text-white text-4xl w-10 h-10 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-bold text-xl text-charcoal mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
